var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tables-settings-table",
      class: {
        empty: _vm.empty,
      },
    },
    [
      _c("m-confirm", {
        ref: "confirm",
        attrs: {
          confirm: "Удалить",
          reset: "Отменить",
          mode: "danger",
          title: "Удаление условия",
        },
      }),
      !_vm.inited
        ? _c("loader", {
            attrs: {
              label: "Данные загружаются",
              active: !_vm.inited,
              height: "300",
            },
          })
        : _vm._e(),
      _vm.inited
        ? _c("div", [
            _c(
              "div",
              { staticClass: "desktop" },
              [
                _vm.empty || _vm.items.length
                  ? _c("scrolled-table", { on: { nextPage: _vm.nextPage } }, [
                      _c("table", { staticClass: "h-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "table-type" }, [
                              _c("div", { staticClass: "h-table__col-title" }, [
                                _vm._v(" Период "),
                              ]),
                            ]),
                            _c("th", { staticClass: "table-columns" }, [
                              _vm._v("Филиалы"),
                            ]),
                            _c("th", {
                              staticClass: "table-actions",
                              attrs: { width: "70" },
                            }),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.items, function (item) {
                            return _c("tr", { key: item.id }, [
                              _c("td", { attrs: { valign: "top" } }, [
                                _vm._v(
                                  _vm._s(
                                    item.period_type !== 6
                                      ? item.name
                                      : item.per_days + " дней"
                                  )
                                ),
                              ]),
                              _c("td", { attrs: { valign: "top" } }, [
                                _vm._v(
                                  _vm._s(
                                    item.filialsNames
                                      ? item.filialsNames
                                      : "Все"
                                  )
                                ),
                              ]),
                              _c("td", { attrs: { valign: "top" } }, [
                                _c(
                                  "div",
                                  { staticClass: "table-settings__actions" },
                                  [
                                    _c("c-button-2", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover.blur.top",
                                          value: "Редактировать",
                                          expression: "'Редактировать'",
                                          modifiers: {
                                            hover: true,
                                            blur: true,
                                            top: true,
                                          },
                                        },
                                      ],
                                      staticClass: "table-settings__edit",
                                      attrs: { size: "iconic", icon: "edit" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toTableSettings(item)
                                        },
                                      },
                                    }),
                                    _c("c-button-2", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover.blur.top",
                                          value: "Удалить",
                                          expression: "'Удалить'",
                                          modifiers: {
                                            hover: true,
                                            blur: true,
                                            top: true,
                                          },
                                        },
                                      ],
                                      staticClass: "table-settings__remove",
                                      attrs: {
                                        size: "iconic",
                                        icon: {
                                          icon: "trash",
                                          color: "secondary",
                                        },
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeTableSettings(item)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.loading
                  ? _c("loader", {
                      attrs: {
                        label: "Данные загружаются",
                        active: _vm.loading,
                        height: "300",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mobile-wrapper" },
              [
                _vm.items.length
                  ? _c(
                      "div",
                      { staticClass: "mobile" },
                      [
                        _c(
                          "horizontal-table",
                          {
                            on: {
                              nextPage: function ($event) {
                                return _vm.$emit("nextPage")
                              },
                            },
                          },
                          [
                            _c("table", { staticClass: "h-table" }, [
                              _c("tbody", [
                                _c(
                                  "tr",
                                  [
                                    _c("th", { attrs: { valign: "top" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "h-table__col-title",
                                          class: {
                                            active: _vm.sortBy === "section",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "sort",
                                                "section"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Период ")]
                                      ),
                                    ]),
                                    _vm._l(_vm.items, function (item) {
                                      return _c(
                                        "td",
                                        {
                                          key: item.id,
                                          attrs: { valign: "top" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.period_type !== 6
                                                  ? item.name
                                                  : item.per_days + " дней"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  [
                                    _c("th", { attrs: { valign: "top" } }, [
                                      _vm._v("Филиалы"),
                                    ]),
                                    _vm._l(_vm.items, function (item) {
                                      return _c(
                                        "td",
                                        {
                                          key: item.id,
                                          attrs: { valign: "top" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.filialsNames
                                                  ? item.filialsNames
                                                  : "Все"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  [
                                    _c("th", { attrs: { valign: "top" } }),
                                    _vm._l(_vm.items, function (item) {
                                      return _c(
                                        "td",
                                        {
                                          key: item.id,
                                          attrs: { valign: "top" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "table-settings__actions",
                                            },
                                            [
                                              _c("c-button-2", {
                                                directives: [
                                                  {
                                                    name: "b-popover",
                                                    rawName:
                                                      "v-b-popover.hover.blur.top",
                                                    value: "Редактировать",
                                                    expression:
                                                      "'Редактировать'",
                                                    modifiers: {
                                                      hover: true,
                                                      blur: true,
                                                      top: true,
                                                    },
                                                  },
                                                ],
                                                staticClass:
                                                  "table-settings__edit",
                                                attrs: {
                                                  size: "iconic",
                                                  icon: "edit",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toTableSettings(
                                                      item
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("c-button-2", {
                                                directives: [
                                                  {
                                                    name: "b-popover",
                                                    rawName:
                                                      "v-b-popover.hover.blur.top",
                                                    value: "Удалить",
                                                    expression: "'Удалить'",
                                                    modifiers: {
                                                      hover: true,
                                                      blur: true,
                                                      top: true,
                                                    },
                                                  },
                                                ],
                                                staticClass:
                                                  "table-settings__remove",
                                                attrs: {
                                                  size: "iconic",
                                                  icon: {
                                                    icon: "trash",
                                                    color: "secondary",
                                                  },
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeTableSettings(
                                                      item
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.loading
                  ? _c("loader", {
                      staticClass: "tables-settings-table__loader",
                      attrs: {
                        label: "Данные загружаются",
                        active: _vm.loading,
                        height: "300",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.empty
              ? _c("div", { staticClass: "tables-settings-table__empty" }, [
                  _vm._v(
                    "Условий для автоматического создания ведомостей пока не добавлено"
                  ),
                ])
              : _vm._e(),
            !_vm.empty && !_vm.loading && !_vm.items.length
              ? _c("div", { staticClass: "tables-settings-table__not-found" }, [
                  _vm._v(
                    " Ничего не найдено. Попробуйте изменить параметры поиска. "
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }